import React from 'react';

import { Form } from 'antd';
import cn from 'classnames';
import Image from 'next/legacy/image'

import { Select } from '@element/index'
import { I18n } from '@utils/index';

import { useCoin } from './useCoin'

import styles from './index.module.less';

const { Item } = Form;

interface SelectCoinFieldProps {
  className?: string;
  name: string;
}

type IParams = {
  form: any,
  name: string,
  options: any[],
  getAvailable: (params: {
    coinCode: string;
    precision: number;
    forceFetch?: boolean;
  }) => Promise<void>
}

const getRenderParams = (params: IParams) => {
  const { form, name, options, getAvailable } = params;
  let value = form.getFieldValue(name);
  const formPrecision = form.getFieldValue('precision');
  const precision = options.find(item => item.value === value)?.precision;
  if (!value && options.length) {
    value = options[0].value;
    form.setFieldValue(name, value);
    getAvailable({ coinCode: value, precision, forceFetch: true })
  }
  // 纠错
  if (formPrecision !== precision) {
    getAvailable({ coinCode: value, precision })
    form.setFieldValue('precision', precision);
  }
  return { value }
}

export const SelectCoinField: React.FC<SelectCoinFieldProps> = (props) => {
  const { name, className } = props;
  const { options, available, getAvailable } = useCoin({ name });
  return (
    <Item className={className} shouldUpdate={(prevValues, curValues) => {
      return prevValues[name] !== curValues[name]
    }}>
      {(form) => {
        const { value } = getRenderParams({ form, name, options, getAvailable });
        return (
          <Item name={name} className={styles.item} rules={[{ required: true, message: I18n.t('yR8ef5sQ') }]}>
            <div className={styles.container}>
              <span className={styles.label}>{I18n.t('yR8ef5sQ')}</span>
              <Select
                value={value}
                theme="dark"
                options={options}
                className={styles.select}
                empty={I18n.t('no.data')}
                onChange={params => {
                  const values = form.getFieldsValue();
                  form.resetFields();
                  getAvailable({ coinCode: params.value as string, precision: params.precision })
                  form.setFieldsValue({
                    ...values,
                    precision: params.precision,
                    [name]: params.value
                  })
                }}
                selectBtnCalssName={styles.selectBtn}
                popoverClass={styles.popover}
                renderValue={(params) => {
                  return (
                    <div className={styles.renderValue}>
                      {!!params?.picturePath && <Image src={params.picturePath} width={24} height={24} alt='kikitrade'/>}
                      <span className={styles.renderValueLabel}>{params?.label}</span>
                    </div>
                  )
                }}
              />
              {!!value && <span className={cn(styles.general_color, styles.available)}>{I18n.t('UYUFE4E9', { available })}</span>}
            </div>
          </Item>
        );
      }}
    </Item>
  );
}
